import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'quangular';
import { IChatDocument } from '@common/models/Chat/IChatDocument';
import { ITableRow } from '@common/models/Document/ITableRow';

@Injectable({
    providedIn: 'root',
})
export class StatsService {

  constructor( private apiService: ApiService) {}

  getChatInfo(start_date: string, end_date: string): Observable<ITableRow> {
    return this.apiService.get<ITableRow>(`admin/stats/chats-info?start_date=${start_date}&end_date=${end_date}`);
  }
  getPowerUsers(limit:number, start_date: string, end_date: string): Observable<string[]> {
    return this.apiService.get<string[]>(`admin/stats/power-users?limit=${limit}&start_date=${start_date}&end_date=${end_date}`);
  }
  getInteractionVsTime(): Observable<ITableRow> {
    return this.apiService.get<ITableRow>(`admin/stats/interactions-vs-time`);
  }
  getUsersVsTime(): Observable<ITableRow> {
    return this.apiService.get<ITableRow>(`admin/stats/users-vs-time`);
  }
  getDesignationUsageVsTime(): Observable<ITableRow> {
    return this.apiService.get<ITableRow>(`admin/stats/designation-usage`);
  }
  getUserInteractionsVsTime(): Observable<ITableRow> {
    return this.apiService.get<ITableRow>(`admin/stats/user-interactions`);
  }
}
